import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Container } from 'semantic-ui-react';
import { flattenToAppURL, flattenHTMLToAppURL } from '@plone/volto/helpers';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Picture from 'volto-deba/components/Picture/Picture';

/**
 * OstatuaJatetxeaView view component class.
 * @function OstatuaJatetxeaView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */

const OstatuaJatetxeaView = ({ content }) => {
  let lang = useSelector((state) => state.intl.locale);
  moment.locale(lang);

  const intl = useIntl();

  const messages = defineMessages({
    general_info: {
      id: 'General information',
      defaultMessage: 'General information',
    },
    ref_num: {
      id: 'Reference number',
      defaultMessage: 'Reference number',
    },
    address: {
      id: 'Address',
      defaultMessage: 'Address',
    },
    phone: {
      id: 'Phone',
      defaultMessage: 'Phone',
    },
    mail: {
      id: 'Mail',
      defaultMessage: 'Mail',
    },
    website: {
      id: 'Website',
      defaultMessage: 'Website',
    },
    characteristics: {
      id: 'Characteristics',
      defaultMessage: 'Characteristics',
    },
  });

  return (
    <Container className="view-wrapper grid">
      <Grid.Row>
        <Grid.Column width={12}>
          {content.title && (
            <h1 className="documentFirstHeading">
              {content.title}
              {content.subtitle && ` - ${content.subtitle}`}
            </h1>
          )}
        </Grid.Column>
        <Grid.Column width={5}>
          {content.description && (
            <p className="documentDescription">{content.description}</p>
          )}
          <>
            <h2>{intl.formatMessage(messages.general_info)}</h2>
          </>
          <ul className="arrow contant-info">
            {content.code && (
              <>
                <li>
                  <strong>{intl.formatMessage(messages.ref_num)}: </strong>
                  {content.code}
                </li>
              </>
            )}
            {content.address && (
              <>
                <li>
                  <strong>{intl.formatMessage(messages.address)}: </strong>
                  {content.map ? (
                    <a href={content.map}>{content.address}</a>
                  ) : (
                    <span>{content.address}</span>
                  )}
                </li>
              </>
            )}
            {content.telephone && (
              <>
                <li>
                  <strong>{intl.formatMessage(messages.phone)}: </strong>
                  {content.telephone}
                </li>
              </>
            )}
            {content.email && (
              <>
                <li>
                  <strong>{intl.formatMessage(messages.mail)}: </strong>
                  <a href={`mailto:${content.email}`} className="top-email">
                    {content.email}
                  </a>
                </li>
              </>
            )}
            {content.web && (
              <>
                <li>
                  <strong>{intl.formatMessage(messages.website)}: </strong>
                  <a href={flattenToAppURL(content.web)}>{content.web}</a>
                </li>
              </>
            )}
          </ul>
          {content?.taxonomy_ezaugarriak && (
            <>
              <h2>{intl.formatMessage(messages.characteristics)}</h2>
              <ul className="arrow">
                {content.taxonomy_ezaugarriak.map((item) => (
                  <li>{item.title}</li>
                ))}
              </ul>
            </>
          )}
          {content.text && (
            <div
              className="ostatuak-text"
              dangerouslySetInnerHTML={{
                __html: flattenHTMLToAppURL(content.text.data),
              }}
            />
          )}
          {/* {content?.taxonomy_zigiluak && (
            <>
              <h2>Zigiluak</h2>
              <ul className="arrow">
                {content?.taxonomy_zigiluak?.map((item) => (
                  <li>
                    <a href={flattenToAppURL(item.token)}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </>
          )} */}
        </Grid.Column>
        <Grid.Column width={7}>
          {content.image && (
            <Picture
              source="newsitem"
              imageBase={`${content['@id']}/@@images/image`}
              alt={content.title}
              lazy={false}
              content={content}
              className="mainPicture"
            ></Picture>
          )}
        </Grid.Column>
      </Grid.Row>
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
OstatuaJatetxeaView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default OstatuaJatetxeaView;
